
export const GET_SINGLEPUR_REQUEST = "GET_SINGLEPUR_REQUEST";
export const GET_SINGLEPUR_SUCCESS = "GET_SINGLEPUR_SUCCESS";
export const GET_SINGLEPUR_FAILURE = "GET_SINGLEPUR_FAILURE";